import _regeneratorRuntime from "E:/AirVenture/frontend/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "E:/AirVenture/frontend/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find-index.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CommonMixin from "@/core/plugins/common-mixin";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { POST, GET, DELETE, PUT } from "@/core/services/store/request.module";
import DatePicker from "@/view/pages/partials/Datepicker";
import ValidationMixin from "@/core/plugins/validation-mixin";
export default {
  mixins: [CommonMixin, ValidationMixin],
  name: "product-adjustment-create",
  data: function data() {
    return {
      adjustment: {
        reference: null,
        date: null,
        reason: null,
        description: null
      },
      pageLoading: false,
      adjustmentId: null,
      lineItemList: [],
      adjustmentItems: [{
        id: null,
        image: null,
        batch: null,
        product: null,
        product_id: null,
        description: null,
        available_qty: null,
        stock_on_hand: null,
        adjusted_qty: null
      }]
    };
  },
  components: {
    DatePicker: DatePicker
  },
  methods: {
    updateDate: function updateDate(date) {
      this.adjustment.date = date;
    },
    setProductImage: function setProductImage(index) {
      try {
        var product_images = this.adjustmentItems[index].product.product_image;

        if (product_images) {
          this.adjustmentItems[index].image = product_images.file.url;
        }
      } catch (error) {
        this.logError(error);
        this.adjustmentItems[index].image = null;
      }
    },
    fixQuantity: function fixQuantity(value, index, type) {
      if (type == "stock_on_hand") {
        this.adjustmentItems[index].adjusted_qty = this.lodash.toSafeInteger(value) - this.lodash.toSafeInteger(this.adjustmentItems[index].available_qty);
      } else if (type == "adjusted_qty") {
        this.adjustmentItems[index].stock_on_hand = this.lodash.toSafeInteger(value) + this.lodash.toSafeInteger(this.adjustmentItems[index].available_qty);
      }
    },
    removeLineItem: function removeLineItem(index, id) {
      var _this = this;

      if (id > 0) {
        _this.$store.dispatch(DELETE, {
          url: "line-item/" + id
        }).then(function () {
          _this.adjustmentItems.splice(index, 1);
        }).catch(function (error) {
          _this.logError(error);
        });
      } else {
        _this.adjustmentItems.splice(index, 1);
      }
    },
    addLineItem: function addLineItem() {
      this.adjustmentItems.push({
        id: null,
        image: null,
        batch: null,
        product: null,
        product_id: null,
        description: null,
        available_qty: null,
        stock_on_hand: null,
        adjusted_qty: null
      });
    },
    updateLineItem: function updateLineItem(product, index) {
      var _this = this;

      try {
        if (_this.lodash.isEmpty(product) === false) {
          _this.adjustmentItems[index].product = product;
          _this.adjustmentItems[index].batch = product.default_batch.id;
          _this.adjustmentItems[index].available_qty = product.available_stock;
          _this.adjustmentItems[index].description = product.description;
          _this.adjustmentItems[index].product_id = product.id;

          var focusElement = _this.$refs["stock_on_hand_".concat(index)];

          if (focusElement[0]) {
            _this.$nextTick(function () {
              return focusElement[0].focus();
            });
          }

          _this.setProductImage(index);
        } else {
          _this.clearLineItem(index);
        }
      } catch (error) {
        _this.clearLineItem(index);

        _this.logError(error);
      }
    },
    clearLineItem: function clearLineItem(index) {
      this.adjustmentItems[index] = new Object({
        id: null,
        image: null,
        batch: null,
        product: null,
        product_id: null,
        description: null,
        available_qty: null,
        stock_on_hand: null,
        adjusted_qty: null
      });
    },
    getLineItems: function getLineItems() {
      var _this = this;

      _this.$store.dispatch(GET, {
        url: "product/get-line-products"
      }).then(function (response) {
        _this.lineItemList = response.data;
      }).catch(function (error) {
        _this.logError(error);
      }).finally(function () {
        _this.setDefaultProduct();
      });
    },
    createAdjustment: function createAdjustment() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _this.$store.dispatch(POST, {
          url: "product/adjustment",
          data: _this.adjustment
        }).then(function (_ref) {
          var data = _ref.data;
          resolve(data.id);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    createAdjustmentLineItem: function createAdjustmentLineItem() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _this.$store.dispatch(PUT, {
          url: "product/adjustment/" + _this.adjustmentId + "/line-item",
          data: {
            line_items: _this.adjustmentItems
          }
        }).then(function (_ref2) {
          var data = _ref2.data;
          resolve(data.id);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    onSubmit: function onSubmit(status) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this = _this2;
                _context.prev = 1;

                if (_this.$refs.adjustmentForm.validate()) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", false);

              case 4:
                _this.formLoading = true;
                _this.adjustment.status = _this.lodash.toSafeInteger(status);

                if (_this.adjustmentId) {
                  _context.next = 10;
                  break;
                }

                _context.next = 9;
                return _this.createAdjustment();

              case 9:
                _this.adjustmentId = _context.sent;

              case 10:
                _context.next = 12;
                return _this.createAdjustmentLineItem();

              case 12:
                _this.formLoading = false;

                _this.$router.go(-1);

                _context.next = 20;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](1);
                _this.formLoading = false;

                _this.logError(_context.t0);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 16]]);
      }))();
    },
    setDefaultProduct: function setDefaultProduct() {
      var _this = this;

      var product = _this.lodash.toSafeInteger(_this.$route.query.product);

      var index = _this.lodash.findIndex(_this.lineItemList, function (row) {
        return row.id = product;
      });

      if (index >= 0 && _this.lodash.isEmpty(_this.lineItemList[index]) === false) {
        _this.updateLineItem(_this.lineItemList[index], 0);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    _this.getLineItems();

    _this.$store.dispatch(SET_BREADCRUMB, [{
      title: "Product",
      route: "product"
    }, {
      title: "Adjustment"
    }, {
      title: "Create"
    }]);
  }
};